import React, {useCallback} from 'react'
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useTelephony} from '../../hooks/useTelephony'

const floatingToolsStyle: React.CSSProperties = {
  position: 'fixed',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
  zIndex: 1051,
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}

const floatingTabStyle: React.CSSProperties = {
  borderRadius: '10px 0 0 10px',
  padding: '8px 12px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
}

export const TelephonyFloatingButton: React.FC = () => {
  const telephony = useTelephony()

  const handleOpenVicidialWebphone = useCallback(async () => {
    if (telephony.vicidialSession.activeSession) {
      await telephony.openWebphone('VICIDIAL', {preferAgentSession: false})
      return
    }

    if (telephony.vicidialSession.connected || telephony.vicidialSession.connecting) {
      await telephony.openWebphone('VICIDIAL', {preferAgentSession: true})
      return
    }

    await telephony.connectVicidialSession()
  }, [telephony])

  if (!telephony.config.vicidial_enabled) {
    return null
  }

  return (
    <div style={floatingToolsStyle} id="global-telephony-floating-tools">
      <OverlayTrigger
        placement='left'
        overlay={<Tooltip id='telephony-vicidial-webphone-tooltip'>VICIdial Webphone</Tooltip>}
      >
        <Button
          style={floatingTabStyle}
          variant={
            telephony.vicidialSession.status === 'INCALL'
              ? 'success'
              : telephony.vicidialSession.connected
              ? 'primary'
              : 'light'
          }
          title='VICIdial Webphone'
          onClick={handleOpenVicidialWebphone}
          disabled={!telephony.vicidialSession.connected}
        >
          <i className='bi bi-telephone fs-4' />
        </Button>
      </OverlayTrigger>
    </div>
  )
}
